import http from '@/http'

const API = {
  listAppVersions: '/operation/v1/appVersions/search', // 查询版本信息列表 post
  getAppVersionsList: '/operation/v1/appVersions/list', // 查询版本号列表 get
  getAppVersionsInfo: '/operation/v1/appVersions/{id}', // 查询版本信息
  updateAppVersions: '/operation/v1/appVersions', // 更新版本信息  post put
  deleteAppVersions: '/operation/v1/appVersions/{id}', // 删除版本信息  delete
  getNextAppVersions: '/operation/v1/appVersions/next/{terminalType}', // 新增版本号显示最新版本号下一个 get

  listOperationDevices: '/operation/v1/operationDevices/search', // 运行设备管理列表 post
  listPrintDevice: '/operation/v1/printDevice/search', // 打印机管理列表 post
  getPrintDeviceStatus: '/operation/v1/printDevice/queryStatus', // 打印机设备状态
}

/**
 * 获取打印内容
 */

export const getPrintTemplate = (options) => {
  console.log(options)
  return http.post({
    ...options,
    url: '/base/v2/blueToothTemplates/manage/getByStore',
  })
}

/**
 * 运行设备管理列表
 * @param options
 * @returns {*}
 */
export function listOperationDevices(options) {
  return http.post({
    ...options,
    url: API.listOperationDevices,
  })
}

/**
 * 打印机管理列表
 * @param options
 * @returns {*}
 */
export function listPrintDevice(options) {
  return http.post({
    ...options,
    url: API.listPrintDevice,
  })
}

/**
 * 打印机管理状态
 * @param options
 * @returns {*}
 */
export function getPrintDeviceStatus(options) {
  return http.get({
    ...options,
    url: API.getPrintDeviceStatus,
  })
}

/**
 * 查询版本信息列表
 * @param options
 * @returns {*}
 */
export function listAppVersions(options) {
  return http.post({
    ...options,
    url: API.listAppVersions,
  })
}

/**
 * 查询版本信息列表
 * @param options
 * @returns {*}
 */
export function getAppVersionsList(options) {
  return http.get({
    ...options,
    url: API.getAppVersionsList,
  })
}
/**
 * 查询版本信息
 * @param options
 * @returns {*}
 */
export function getAppVersionsInfo(options) {
  const {
    params: { id },
  } = options
  return http.get({
    ...options,
    url: `/operation/v1/appVersions/${id}`,
  })
}

/**
 * 更新版本信息
 * @param options
 * @returns {*}
 */
export function updateAppVersions(options) {
  const {
    data: { id },
  } = options
  let method = !id ? 'post' : 'put'
  return http[method]({
    ...options,
    url: API.updateAppVersions,
  })
}

/**
 * 新增版本号显示最新版本号下一个
 * @param options
 * @returns {*}
 */
export function getNextAppVersions(options) {
  const {
    params: { terminalType },
  } = options
  return http.get({
    ...options,
    url: `/operation/v1/appVersions/next/${terminalType}`,
  })
}

/**
 * 删除版本号
 * @param options
 * @returns {*}
 */
export function deleteAppVersions(options) {
  const {
    data: { id },
  } = options
  return http.delete({
    ...options,
    url: `/operation/v1/appVersions/${id}`,
  })
}

/**
 * 云打印机列表
 * @param options
 * @returns {*}
 */
export function getCloudPrintDevice(options) {
  return http.post({
    ...options,
    url: '/base/v1/cloudPrintDevice/list',
  })
}

/**
 * 云打印
 * @param options
 * @returns {*}
 */
export function cloudPrint(options) {
  return http.post({
    ...options,
    url: '/order/cloud/print/v1/print',
  })
}
/**
 * 批量云打印
 * @param options
 * @returns {*}
 */
export function cloudAllPrint(options) {
  return http.post({
    ...options,
    url: '/order/cloud/print/v1/mergePrint',
  })
}

/**
 * 云打印-模版选择
 * @param options
 * @returns {*}
 */
export function getTemplate(options) {
  return http.get({
    ...options,
    url: '/base/bluetoothCustomPrintTemplate/getUsingTemplates',
  })
}

export function printVersion(options) {
  const {
    data: { id },
  } = options
  return http.get({
    ...options,
    url: `/order/purchase/print//${id}`,
  })
}

export default API
